/**
 * HomeSLHomeInvoicesDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLHomeInvoicesDemo
 */

import { useHomeSLHomeInvoicesDemoLogic } from '@/hooks/traits/useHomeSLHomeInvoicesDemoLogic';
import type { HomeSLHomeInvoicesDemoConfig } from '@/hooks/traits/useHomeSLHomeInvoicesDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoInvoicePageItem } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { HomeSLDemoInvoicePageTourView } from '@/components/traits/HomeSLDemoInvoicePageTourView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeSLHomeInvoicesDemoViewProps {
  config?: Partial<HomeSLHomeInvoicesDemoConfig>;
}

export function HomeSLHomeInvoicesDemoView({ config: propsConfig }: HomeSLHomeInvoicesDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLHomeInvoicesDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoInvoicePageItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLHomeInvoicesDemo">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" direction="vertical"><HomeSLDemoInvoicePageTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLHomeInvoicesDemoView;
